export enum EMultasStatus {
    PAGADA = 'PAGADA',
    EN_TRAMITE_DE_COBRANZA = 'EN TRÁMITE DE COBRANZA'
}
